<template>
  <div class="full-board-top">
    <TaiXiuFullVideo class="full-board-top__video" :arena-id="table.arenaId" />
    <TaiXiuBoardHeader
      class="full-board-top__header"
      :table="table"
      :is-rolling="isRolling"
      use-name
      float-result
    />
  </div>
</template>

<script>
import TaiXiuFullVideo from '@/components/tai-xiu/tai-xiu-full-video.vue';
import TaiXiuBoardHeader from '@/components/tai-xiu/tai-xiu-board-header.vue';

export default {
  name: 'TaiXiuFullBoardTop',
  components: {
    TaiXiuFullVideo,
    TaiXiuBoardHeader,
  },
  props: {
    table: {
      type: Object,
      required: true,
    },
    lastResult: {
      type: Number,
      default: null,
    },
    isRolling: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.full-board-top {
  width: 100%;
  min-width: 0;
  background: transparent;
}

.full-board-top__video {
  width: 100%;
  max-width: none;
}

</style>
